import React, { Fragment, useEffect, useState } from "react";

import { TopicSelector } from "components/explore/TopicSelector";
import { useNichesQuery } from "queries";
import { INiche } from "services/types";
import { NicheBrowser } from "components/niches/NicheBrowser";
import { ViewControl } from "components/niches";

import "./ExploreNichesPage.scss";
import { FooterAds } from "components/ads/FooterAds";
import { ContentPageSkyscraperEnum } from "components/ads/config/units/contentPageSkyscraper";
import { WithSideAds } from "components/ads";

export const ExploreNichesPage = () => {
  const [order, setOrder] = useState<string>("subscribers");
  const [niches, setNiches] = useState<INiche[]>([]);

  const { status, data } = useNichesQuery({
    order: order,
  });

  useEffect(() => {
    document.title = "Top Niches | RedGIFs";
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (status === "success" && data) {
      const items = data.niches.filter((niche: INiche): boolean => {
        return niche.previews.length >= 4;
      });

      setNiches(items);
    }
  }, [status, data]);

  const onSortChange = (value: string) => {
    console.debug(`Sort order changed to ${value}`);
    setOrder(value);
  };

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
          ContentPageSkyscraperEnum.ContentPageSkyscraperL2,
          ContentPageSkyscraperEnum.ContentPageSkyscraperL3,
        ]}
        rightAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
          ContentPageSkyscraperEnum.ContentPageSkyscraperR2,
          ContentPageSkyscraperEnum.ContentPageSkyscraperR3,
        ]}
      >
        <div className="wide page nichesPage">
          <TopicSelector active="niches" />

          <ViewControl
            order={order}
            onSortChange={onSortChange}
            isNiche
          />

          {niches.length > 0 && <NicheBrowser
            niches={niches}
          />}
        </div>
      </WithSideAds>
      <FooterAds/>
    </Fragment>
  );
};
